import { QuillOptions } from "quill";

export const richTextToolbarOptions = [
  ["bold", "italic", "underline", "strike"],
  [{ script: "sub" }, { script: "super" }],
  [{ header: [1, 2, 3, false] }],
  [{ color: [] }, { background: [] }],
  [{ list: "ordered" }, { list: "bullet" }],
  [{ indent: "-1" }, { indent: "+1" }],
  [{ align: [] }],
  ["blockquote", "link", "clean", "source"],
];

export function getRichTextQuillOptions(placeholder?: string): QuillOptions {
  return {
    theme: "snow",
    placeholder,
    modules: {
      toolbar: richTextToolbarOptions,
    },
  };
}
